import NotFoundIcon from '../../../assets/image/sponsor/404.svg';

const NoSearchResult = () => {
  return (
    <div className="flex flex-col items-center justify-center px-3 text-sm text-gray-800 flex-1">
      <div className="flex flex-col justify-center items-center gap-6">
        <img src={NotFoundIcon} alt="not found" className="w-16" />
        <span>موردی وجود ندارد</span>
      </div>
    </div>
  );
};

export default NoSearchResult;
